import styles from './CmsButton.module.scss';
import { trackInteraction } from '@components/hooks';
import React from 'react';
import classNames from 'classnames';
import { Button, Link } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const CmsButton = ({
  className,
  interactionId,
  isAnimated = false,
  isElevated = false,
  link,
  shape,
  size = 'default',
  text,
  theme = 'primary',
  variant,
}) => (
  <Button
    className={classNames(styles.button, className)}
    isAnimated={isAnimated}
    isElevated={isElevated}
    onClick={() => trackInteraction(interactionId)}
    render={<Link target={link?.target} to={link?.url} />}
    shape={shape}
    size={size}
    theme={theme}
    variant={variant}
  >
    {text}
  </Button>
);

CmsButton.propTypes = {
  className: PropTypes.string,
  interactionId: PropTypes.string,
  isAnimated: PropTypes.bool,
  /** Elevated from background element */
  isElevated: PropTypes.bool,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
  shape: PropTypes.oneOf(['bubble', 'squared']),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  text: PropTypes.string.isRequired,
  theme: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'ghost',
    'contrast',
  ]),
  variant: PropTypes.oneOf(['link', 'outline', 'bubble']),
};

export default CmsButton;
